import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import { IAccountDetailsDTO, IAccountListDTO, IAccountsDAO } from '../accounts.dao';
import { IPaginationParams } from '../shared.dto';

class AccountsDAO extends IAccountsDAO {
    private readonly listURL: string = 'account/list';
    private readonly userListURL: string = 'account/list/user';
    private readonly crudURL: string = 'account/{accountId}';
    private readonly createURL: string = 'account';
    private readonly reservedSubdomains: string = 'reserved-subdomains';

    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getAccounts(params: IPaginationParams): Promise<IAccountListDTO> {
        const response = await this.apiClient.get<IAccountListDTO>(this.listURL, params);
        return response.parsedResponse;
    }

    public async getUserAccounts(params: IPaginationParams): Promise<IAccountListDTO> {
        const response = await this.apiClient.get<IAccountListDTO>(this.userListURL, params);
        return response.parsedResponse;
    }

    public async readAccount(accountId: number): Promise<IAccountDetailsDTO> {
        const response = await this.apiClient.get<IAccountDetailsDTO>(this.crudURL, {accountId: accountId});
        return response.parsedResponse;
    }

    public async createAccount(name: string, salesforceAccountId: string, allowedProviders: string[]): Promise<IAccountDetailsDTO> {
        const response = await this.apiClient.post<IAccountDetailsDTO>(this.createURL, {
            name: name,
            salesforceAccountId: salesforceAccountId,
            allowedProviders: allowedProviders
        });
        return response.parsedResponse;
    }

    public async updateAccount(params: {name: string; accountId: number}): Promise<IAccountDetailsDTO> {
        const response = await this.apiClient.put<IAccountDetailsDTO>(this.crudURL, params);
        return response.parsedResponse;
    }

    public async getReservedSubdomains(): Promise<string[]> {
        const response = await this.apiClient.get<string[]>(this.reservedSubdomains);
        return response.parsedResponse;
    }

    public async deleteAccount(params: {accountId: number}): Promise<void> {
        await this.apiClient.delete(this.crudURL, params);
    }
}

export { AccountsDAO };
